/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey, category } = {}) {
    const queryParams = new URLSearchParams();
    if (searchKey) queryParams.set('search', searchKey);
    if (category) queryParams.set('category', category);

    const queryString = queryParams.toString();
    const url = queryString ? `${this.url}?${queryString}` : this.url;
    return axios.get(url);
  }
}

export default new CannedResponse();
